import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/i18n/LangProvider";
import Home from "@/pages/Home";
import QuoteForm from "@/pages/QuoteForm";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:lang" element={<Home />} />
            <Route path="/orcamento" element={<QuoteForm />} />
            <Route path="/:lang/orcamento" element={<QuoteForm />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
